import { makeResolvedArtifactWrappers } from './makeResolvedArtifactWrappers';
import { useResolvedRuleName } from './useResolvedRuleName';
import { useResolvedSegmentName } from './useResolvedSegmentName';
import { useResolvedWorkflowName } from './useResolvedWorkflowName';

const workflow = makeResolvedArtifactWrappers(useResolvedWorkflowName);
const segment = makeResolvedArtifactWrappers(useResolvedSegmentName);
const rule = makeResolvedArtifactWrappers(useResolvedRuleName);

export const WorkflowArtifactListItem = workflow.ListItem;
export const WorkflowArtifactCard = workflow.Card;
export const SegmentArtifactListItem = segment.ListItem;
export const SegmentArtifactCard = segment.Card;
export const RuleArtifactListItem = rule.ListItem;
export const RuleArtifactCard = rule.Card;
